export const customStyle = {
  control: (provided, state) => {
    return {
      ...provided,
      border: 0,
      borderColor: state.isFocused ? "#023A66" : provided.borderColor,
      "&:hover": {
        borderColor: "#023A66 !important",
      },
    };
  },

  option: (styles, { data, isFocused, isSelected, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? null : isSelected ? "#023A66" : data.color,
    color: isDisabled ? "#ccc" : isSelected ? "white" : data.color,
    cursor: isDisabled ? "not-allowed" : "default",
  }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),

  menuList: (provided, state) => ({
    ...provided,
    zIndex: 10,
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

export const customStyleForMultiSelect = {
  control: (provided, state) => {
    return {
      ...provided,
      border: 0,
      borderColor: state.isFocused ? "#ABE3FB" : provided.borderColor,
      "&:hover": {
        borderColor: "#ABE3FB !important",
      },
    };
  },

  option: (styles, { data, isFocused, isSelected, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? null : isSelected ? "#EBF9FF" : data.color,
    color: isDisabled ? "#ccc" : isSelected ? "#023A66" : data.color,
    cursor: isDisabled ? "not-allowed" : "default",
    padding: "10px 14px",
    marginTop: "8px",
    marginBottom: "8px",
    height: data.label.length > 31 ? "80px" : "44px",
    display: "flex",
    alignItems: "center",
    "&:active": {
      backgroundColor: "#EBF9FF",
    },
    "&:hover": {
      backgroundColor: "#EBF9FF",
    },
  }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),

  menuList: (provided, state) => ({
    ...provided,
    zIndex: 10,
    padding: "0px 10px 14px",
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),

  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#EBF9FF", // Custom background color for selected chips
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#023A66", // Text color inside the chip
    fontSize: "14px",
    fontFamily: "urwgeometric-medium",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#023A66", // Color of the clear icon
    ":hover": {
      backgroundColor: "#EBF9FF",
      color: "#023A66",
    },
  }),
};
